import React, { useState, useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import InvoiceList from './InvoiceList'
import InvoiceDetailDrawer from './InvoiceDetailDrawer'
import { isMockMode } from './mockData'
import '../../../styles/hmiReskin.css'

function SubcontractorInvoicesPage({ url }) {
  const history = useHistory()
  const location = useLocation()
  const mockBanner = isMockMode() ? (
    <div style={{
      background: '#fff3d9', color: '#8c5b00', padding: '6px 16px',
      fontSize: 12.5, fontWeight: 600, borderBottom: '1px solid #f0c66e',
      textAlign: 'center'
    }}>
      MOCK MODE — all data is in-memory only. Actions update local state. Refresh the page to reset. Remove <code>?mock=1</code> to use the real API.
    </div>
  ) : null
  const [selectedId, setSelectedId] = useState(() => new URLSearchParams(location.search).get('invoiceId'))
  const [listRefreshKey, setListRefreshKey] = useState(0)

  useEffect(() => {
    const invoiceId = new URLSearchParams(location.search).get('invoiceId')
    setSelectedId(invoiceId || null)
  }, [location.search])

  const handleSelect = useCallback((id) => {
    setSelectedId(id)
    const params = new URLSearchParams(location.search)
    params.set('invoiceId', id)
    history.replace({
      pathname: location.pathname,
      search: `?${params.toString()}`
    })
  }, [history, location.pathname, location.search])

  const handleClose = useCallback(() => {
    setSelectedId(null)
    const params = new URLSearchParams(location.search)
    params.delete('invoiceId')
    history.replace({
      pathname: location.pathname,
      search: params.toString() ? `?${params.toString()}` : ''
    })
  }, [history, location.pathname, location.search])

  // Called after approve/pay/void/adjust so list refreshes
  const handleStateChange = useCallback(() => {
    setListRefreshKey(k => k + 1)
  }, [])

  return (
    <div className="hmi-page" style={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {mockBanner}
      {/* Page Header */}
      <div className="page-head">
        <div className="crumbs">
          <a href="/hmi-v2">HMI</a>
          <span className="sep">›</span>
          <span className="here">Subcontractor Invoices</span>
        </div>
        <div className="title-row">
          <h1>Subcontractor Invoices</h1>
          <span className="meta">Review, approve, and pay spray-sub invoices</span>
        </div>
      </div>

      {/* Split-view body */}
      <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
        {/* Left: invoice list */}
        <div style={{
          flex: selectedId ? '0 0 50%' : '1 1 100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          borderRight: selectedId ? '1px solid var(--line-1, #e0e8eb)' : 'none',
          transition: 'flex 0.15s ease',
        }}>
          <InvoiceList
            url={url}
            selectedId={selectedId}
            onSelect={handleSelect}
            refreshKey={listRefreshKey}
          />
        </div>

        {/* Right: detail drawer */}
        {selectedId && (
          <div style={{ flex: '0 0 50%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <InvoiceDetailDrawer
              url={url}
              invoiceId={selectedId}
              onClose={handleClose}
              onStateChange={handleStateChange}
            />
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
})

export default connect(mapStateToProps)(SubcontractorInvoicesPage)
